import initialState from './state.js'

export default {
  RESET_MARIA_CAMPAIGN_MODULE(state) {
    Object.keys(initialState).forEach((key) => {
      state[key] = initialState[key]
    })
  },
  SET_MARIA_CAMPAIGN(state, payload) {
    state.mariaCampaign = payload
  },
}
